export const EventListFilter = {
	TEAM:          'team',
	CLUB:          'club',
	LEAGUE:        'league',
	SPORT:         'sport',
	TEAM_CATEGORY: 'teamCategory',
	EVENT_TOPIC:   'eventTopic',
};
